export default {
  contentHolder: {
    position: 'relative'
  }
};